import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DatePicker, Icon, Tooltip, Badge } from 'antd';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import flattenDeep from 'lodash/flattenDeep';
import InfiniteScroll from 'react-infinite-scroll-component';

import './index.scss';

import { MODULE_DATA } from '../../../../../data/config/constants';
import { MODULE_CONFIG } from '../../../../../data/config/urls'
import { getProcessedSelectedFilters } from '../../../../../data/config/utils';
import { IMG_EMPTY_MSG } from '../../../../../data/assets/img';

import CloseTag from '../../../../../components/closetag';
import ShowMessage from '../../../../../components/showmessage';
import ConversationItem from '../../../components/conversationitem';
import ConversationItemLoader from '../../../components/conversationitem/loaders';
import Filters from '../../../components/filters';
import ErrorBoundary from '../../../../../components/errorboundary';

const { RangePicker } = DatePicker;

export default class HistoryList extends Component {
  constructor() {
    super();
    this.showFilterLayout = this.showFilterLayout.bind(this);
    this.hideFilterLayout = this.hideFilterLayout.bind(this);

    this.state = {
      filter_visibility: {
        visible: false,
        animation: 'ori-translate-down',
      }
    };
  }

  componentDidMount() {
    if (MODULE_CONFIG.HISTORY.FILTER_ON_PRESS_ENTER)
      document.addEventListener("keyup", this.onPressEnterOnPage);
  }

  componentWillUpdate() {
    if (this.headerContainer) {
      this.headerContainerHeight = this.headerContainer.offsetHeight;
    }
  }

  componentWillUnmount() {
    if (MODULE_CONFIG.HISTORY.FILTER_ON_PRESS_ENTER)
      document.removeEventListener("keyup", this.onPressEnterOnPage);
  }

  onPressEnterOnPage = event => {
    const { filter_visibility } = this.state
    if (filter_visibility.visible && event.key === 'Enter')
      this.handleApplyFilter()
  }

  showFilterLayout = () => {
    this.setState({
      filter_visibility: {
        ...this.state.filter_visibility,
        visible: true,
        animation: 'ori-translate-down'
      }
    });
  };

  hideFilterLayout = () => {
    this.setState({
      filter_visibility: {
        ...this.state.filter_visibility,
        animation: 'ori-fade-out-up',
      }
    }, () => {
      setTimeout(() => {
        this.setState({
          filter_visibility: {
            ...this.state.filter_visibility,
            visible: false
          }
        });
      }, 400)
    });
  };

  handleFilterUpdate = (filterKey, value) => {
    let { actions } = this.props;
    let payload = { filterKey, value };
    actions.updateHistoryFilterSelection(payload);
  };

  handleClearFilter = () => {
    let { actions } = this.props;
    actions.clearHistoryFilter();
  };

  handleApplyFilter = () => {
    this.hideFilterLayout();
    this.props.applyFilter();
  };

  handleFilterTagClose = filter_item => {
    let { actions } = this.props;
    actions.removeHistoryFilterItem(filter_item).then(this.handleApplyFilter);
  };

  loadMoreHistory = () => {
    const { actions, selected_date_range, chat_history_list, selected_filters, agentId } = this.props;
    let processed_filters = getProcessedSelectedFilters(selected_filters);
    let payload = {
      agentId,
      skip: chat_history_list.length,
      required: MODULE_DATA.HISTORY.LOAD_MORE_HISTORY_COUNT,
      filters: {
        ...processed_filters,
        startDate: selected_date_range && selected_date_range.length > 0 ? selected_date_range[0] : "",
        endDate: selected_date_range && selected_date_range.length > 0 ? selected_date_range[1] : "",
      }
    };
    actions.loadMoreHistory(payload);
  };

  setHeaderContainerRef = el => { this.headerContainer = el; };

  render() {
    const { filter_visibility } = this.state;
    const { selected_date_range, chat_history_list, load_more_history, total_history_count, screen_height, filters, selected_filters, current_session_id, handleChatItemClicked, handleDateRangeChange, event_permissions } = this.props;
    const header_container_height = this.headerContainerHeight ? this.headerContainerHeight : 60;
    const app_header_height = 60;
    const is_selected_filters_empty = (isEmpty(selected_filters) || (!isEmpty(selected_filters) && flattenDeep(Object.values(selected_filters)).length === 0));
    return (
      <div className="ori-relative ori-full-width ori-full-parent-height oriHistoryListContainer">
        <div className="ori-relative ori-b-border-light historyHeaderContainer" ref={this.setHeaderContainerRef}>
          <RangePicker className="ori-b-mrgn-5 ori-full-width rangePickerContainer" format="DD-MM-YYYY" placeholder={['Start Date', 'End Date']} value={selected_date_range} onChange={handleDateRangeChange} />
          {
            !filter_visibility.visible &&
            <div className="ori-absolute ori-animated ori-fade-in ori-cursor-ptr ori-lr-pad-5 alignFilter" onClick={() => { this.showFilterLayout(); }}>
              <Badge className="historyBadge" count={total_history_count - chat_history_list.length} overflowCount={9999}>
                <div className="ori-font-light ori-flex-column alignHeaderIcon">
                  <Tooltip title={<span className="ori-font-xs"> {total_history_count} Chat history found</span>}>
                    <Icon type="filter" className="ori-font-18" />
                  </Tooltip>
                  <p className="title">FILTER</p>
                </div>
              </Badge>
            </div>
          }
          {
            filter_visibility.visible &&
            <div className="ori-absolute ori-animated ori-fade-in ori-cursor-ptr ori-lr-pad-5 ori-font-light ori-flex-column alignHeaderIcon alignClose" onClick={this.hideFilterLayout}>
              <Icon type="close" />
            </div>
          }
          <div className="ori-lr-pad-5 ori-flex-row ori-flex-wrap closeTagContainer">
            {
              !is_selected_filters_empty &&
              flattenDeep(Object.values(selected_filters)).map((item, index) => {
                return (
                  <div key={index} className="ori-animated ori-zoom-in ori-b-mrgn-5 ori-r-mrgn-5">
                    <CloseTag container_class="ori-bg-default ori-border-radius-10 ori-border-light" tag_item={item} handleTagClose={this.handleFilterTagClose} label={item.label} />
                  </div>
                );
              })
            }
          </div>
        </div>
        <div className={classNames("ori-relative", { "ori-display-none": !filter_visibility.visible })}>
          <div className="ori-absolute ori-overflow-hidden filterWrapper" style={{ height: screen_height - app_header_height - header_container_height }}>
            <div className="ori-relative ori-full-parent-height">
              <div className={classNames(`ori-absolute  ori-animated ori-bg-white filterOptionContainer ${filter_visibility.animation}`)}>
                <Filters container_height={screen_height - app_header_height - header_container_height} filter_container_height={header_container_height} screen_height={screen_height} filters={filters} selected_filters={selected_filters} handleFilterUpdate={this.handleFilterUpdate} handleFilterTagClose={this.handleFilterTagClose} handleClearFilter={this.handleClearFilter} handleApplyFilter={this.handleApplyFilter} />
              </div>
            </div>
          </div>
        </div>
        {
          chat_history_list && chat_history_list.length === 0 &&
          <div className="ori-absolute alignNoHistoryFound">
            <ShowMessage img_src={IMG_EMPTY_MSG} message="No chat history found" height={100} width={100} />
          </div>
        }
        {
          chat_history_list && chat_history_list.length > 0 &&
          <div id="historyItemsContainer" className="ori-overflow-auto" style={{ maxHeight: screen_height - app_header_height - header_container_height }} >
            <InfiniteScroll
              scrollableTarget="historyItemsContainer"
              dataLength={chat_history_list.length}
              hasMore={load_more_history}
              scrollThreshold={0.9}
              loader={<ConversationItemLoader />}
              next={this.loadMoreHistory}
            >
              {
                chat_history_list.map(chat_item => {
                  return (
                    <ErrorBoundary key={chat_item.sessionId}>
                      <ConversationItem event_permissions={event_permissions} chat_item={chat_item} handleChatItemClicked={handleChatItemClicked} active={current_session_id && current_session_id === chat_item.sessionId} fade_in />
                    </ErrorBoundary>
                  );
                })
              }
            </InfiniteScroll>
          </div>
        }
      </div>
    );
  }
}

HistoryList.propTypes = {
  actions: PropTypes.object,
  selected_date_range: PropTypes.array,
  chat_history_list: PropTypes.array,
  load_more_history: PropTypes.bool,
  total_history_count: PropTypes.number,
  current_session_id: PropTypes.string,
  screen_height: PropTypes.number,
  filters: PropTypes.array.isRequired,
  selected_filters: PropTypes.object.isRequired,
  handleChatItemClicked: PropTypes.func,
  handleDateRangeChange: PropTypes.func,
  applyFilter: PropTypes.func,
  event_permissions: PropTypes.object,
  agentId: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/history/historylist/index.js